import React, { useEffect, useRef } from "react";
import hasContainer from "helpers/has-container";

const CustomHtmlCode = ({ data }) => {
    const fillContainerRef = useRef(null);

    useEffect(() => {
        if (data && data.htmlCode && data.htmlCode.length > 0) {
            const dataChild = data.htmlCode[0].children[0];
            if (dataChild.marks.length === 1 && dataChild.marks[0] === "code") {
                const code = dataChild.text;
                fillContainerRef.current.innerHTML = code;
            }
        }
        
        if (data && data.scriptCode && data.htmlCode.length > 0) {
            const dataChild = data.scriptCode[0].children[0];
            if (dataChild.marks.length === 1 && dataChild.marks[0] === "code") {
                const code = dataChild.text;
                const scriptElement = document.createElement("script");
                scriptElement.text = code;
                document.body.appendChild(scriptElement);
            }
        }
    }, [data]);

    return (
        <div className={`${hasContainer(data?.moduleSettings?.hasContainer) !== "container" ? "p-0" : "container"}`}>
            <div
                ref={fillContainerRef}
                style={hasContainer(data?.moduleSettings?.hasContainer) !== "container" ? { display: "block" } : { maxWidth: "1200px", display: "block" }}                
            />
        </div>
    );
};

export default CustomHtmlCode;
